import { ResponseDataTest } from '../../../../models/responseDataTest'
import { agroApi } from '../../api'
import { ResponseDataGet } from '../../../../models/responseDataGet'
import { EntVetProduct } from '../../../../models/handBooks/vetProduct'
import { EntTypeTransportFilter } from '../../../../models/filters/typeTransportFilter'
import { Paths } from '../../../../paths'

export const veterinaryProductTypesApi = agroApi.injectEndpoints({
	endpoints: builder => ({
		getVeterinaryProductTypeList: builder.query<
			ResponseDataGet<EntVetProduct>,
			EntTypeTransportFilter
		>({
			query: filter => ({
				url: `${Paths.handbooks.typeOfVeterinaryProduct}/get-all`,
				method: 'POST',
				body: JSON.stringify(filter),
			}),
		}),
		getVeterinaryProductTypeById: builder.query<ResponseDataTest<EntVetProduct>, number>({
			query: id => ({
				url: `${Paths.handbooks.typeOfVeterinaryProduct}/${id}`,
				method: 'GET',
			}),
		}),
		addVeterinaryProductType: builder.mutation<ResponseDataTest<EntVetProduct>, EntVetProduct>({
			query: body => ({
				url: `${Paths.handbooks.typeOfVeterinaryProduct}`,
				method: 'POST',
				body: JSON.stringify(body),
			}),
		}),
		editVeterinaryProductType: builder.mutation<ResponseDataTest<EntVetProduct>, EntVetProduct>({
			query: body => ({
				url: `${Paths.handbooks.typeOfVeterinaryProduct}`,
				method: 'PUT',
				body: JSON.stringify(body),
			}),
		}),
		deleteVeterinaryProductType: builder.mutation<ResponseDataTest<EntVetProduct>, number>({
			query: id => ({
				url: `${Paths.handbooks.typeOfVeterinaryProduct}/${id}`,
				method: 'DELETE',
			}),
		}),
	}),
	overrideExisting: false,
})

export const {
	useAddVeterinaryProductTypeMutation,
	useDeleteVeterinaryProductTypeMutation,
	useEditVeterinaryProductTypeMutation,
	useLazyGetVeterinaryProductTypeListQuery,
} = veterinaryProductTypesApi
